"use strict";

var _classCallCheck = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../../utils"),
    mixin = _require.mixin;

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var WindowEventHandlersImpl = require("./WindowEventHandlers-impl").implementation;

var HTMLFrameSetElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLFrameSetElementImpl, _HTMLElementImpl);

  function HTMLFrameSetElementImpl() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, HTMLFrameSetElementImpl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HTMLFrameSetElementImpl)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this._proxyWindowEventsToWindow();

    return _this;
  }

  return HTMLFrameSetElementImpl;
}(HTMLElementImpl);

mixin(HTMLFrameSetElementImpl.prototype, WindowEventHandlersImpl.prototype);
module.exports = {
  implementation: HTMLFrameSetElementImpl
};